var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSubnavNote(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.111 0a.556.556 0 01.556.556v1.666a.555.555 0 101.11 0v-1.11h.556A1.667 1.667 0 0115 2.777V16.11a1.667 1.667 0 01-1.667 1.667H3.89a1.667 1.667 0 01-1.667-1.667V2.778A1.667 1.667 0 013.89 1.11H5V.556a.556.556 0 111.111 0v1.666a.556.556 0 001.111 0v-1.11h3.333V.555A.555.555 0 0111.111 0zM5 6.667a.556.556 0 100 1.11h7.222a.556.556 0 000-1.11H5zM4.444 10A.556.556 0 015 9.444h3.889a.556.556 0 010 1.112H5A.556.556 0 014.444 10zM5 12.222a.556.556 0 000 1.111h6.111a.555.555 0 100-1.11H5z",
    fill: "#2A848E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.889 20A3.889 3.889 0 010 16.111V2.223h1.111v13.889a2.778 2.778 0 002.778 2.777h9.444V20H3.89zM16.667 3.89a1.667 1.667 0 013.333 0v1.666h-3.333V3.889zm0 11.11V6.667H20V15l-1.667 2.223L16.667 15z",
    fill: "#2A848E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubnavNote);
export default ForwardRef;